export { default } from './PanResponderAdapter';
